/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { Drawer, Menu, Avatar, Typography, Badge, Row, Col, Modal } from "antd";
import { push } from "connected-react-router";
/* Package JSON Import will be here */

/* Project Import will be here */
import { logOut } from "reducers/session";
import { appRoutesConst } from "app/navigation";
import { clearAttrFilter } from "reducers/filter/attrFilter";
import { clearHistoryFilter } from "reducers/orderHistory/historyFilter";
import fileExclamation from "assets/img/file-exclamation.png"
import AppVersion from "components/reusable/AppVersion";
import { Spinner } from "components/Spinner"
import IvyLogoWithoutName from "assets/img/ivy/ivy-logo-without-name.png";
import { navigateToMyRewards } from "app/navigation";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
const { confirm } = Modal;
/* Const,Let & Var will be here */

class DrawerMenu extends Component {
    navigateToHome = () => {
        const pathName = this.props.router.location.pathname;

        if (pathName !== appRoutesConst.home && this.props.appSettings.isEnableHomePage) {
            this.props.actions.push(appRoutesConst.home);
        }
        this.props.drawerMenuClose();
    }

    getTitle = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col span={6}>
                        <Avatar
                            size="large"
                            style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
                            onClick={this.navigateToHome}
                        >
                            {this.props.retailer.retailername.charAt(0)}
                        </Avatar>
                    </Col>
                    <Col span={18}>
                        <Text className="drawer-head-font text-white p-name-wrap-three-line" strong>{this.props.retailer.retailername}</Text>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    getTitleWithLink = () => {
        return (
            <React.Fragment>
                <Link
                    onClick={this.props.drawerMenuClose}
                    to={appRoutesConst.profile}
                >
                    {this.getTitle()}
                </Link>
            </React.Fragment>
        )
    }

    /* Logout button confirmation modal */
    confirmLogout = () => {
        this.props.drawerMenuClose();

        confirm({
            title: this.props.translate("common.alerts.confirmation.logoutConfirmationModalTitle"),
            centered: true,
            okText: this.props.translate("common.buttons.ok"),
            cancelText: this.props.translate("common.buttons.cancel"),
            onOk: () => {
                this.props.actions.logOut();
            }
        });
    }


    navigateToMyRewards = () => {
        this.props.actions.navigateToMyRewards();
        this.props.drawerMenuClose();
    }

    /* Clear the applied attr filter from product list page before navigating to sales return or return change page */
    onReturnLink = () => {
        this.props.actions.clearAttrFilter();
        this.props.drawerMenuClose();
    }

    /* Clear the history filter when my orders and my return orders menu click */
    onHistoryLink = () => {
        this.props.actions.clearHistoryFilter();
        this.props.drawerMenuClose();
    }

    /* Menu icon */
    getMenuIcon = (item) => {
        let icon = null;
        if (item.TCode === "Complaints")
            icon = (<img className="pr-2" src={fileExclamation} alt="" />);
        else
            icon = (<i className={`${item.Icon} fa-lg pr-2`} aria-hidden="true"></i>);

        return icon;
    }

    /* Render menu list item based on menu config API response */
    getResponseMenuItem = (item) => {
        const { translate, notifications, cart, orderHistory } = this.props;

        /* Menu click event */
        let event = null;
        if (item.TCode === "SalesReturn" || item.TCode === "ExchangeReturn")
            event = this.onReturnLink;
        else if (item.TCode === "MyOrders" || item.TCode === "SalesReturnHistory" || item.TCode === "CancelOrder")
            event = this.onHistoryLink;
        else
            event = this.props.drawerMenuClose;

        /* Count badge */
        let countBadge = null;
        if (item.TCode === "MyOrders" && !orderHistory.list.isLoading) {
            countBadge = (<Badge className="ant-badge-green ml-1" showZero={true} count={orderHistory.list.totalCount || 0} overflowCount={999} />);
        }
        else if (item.TCode === "MyCart" && !cart.isLoading) {
            countBadge = (<Badge className="ant-badge-green ml-1" showZero={true} count={(cart.ids.length + cart.freeProducts.length) || 0} overflowCount={99} />);
        }
        else if (item.TCode === "Notifications") {
            countBadge = (<Badge className="ant-badge-green ml-1" showZero={true} count={notifications.count} overflowCount={99} />);
        }

        return (
            <Link
                onClick={event}
                to={item.Target}
            >
                {translate(`common.links.${item.LCode}`)}

                {/* Check for count badge */}
                {countBadge !== null && countBadge}
            </Link>
        );
    }

    drawerFooter = () => {
        return (
            <React.Fragment>
                <AppVersion isFromDrawer={true} />

                <img onClick={() => window.open(window.footerLogoRedirectUrl)} className="copyright-footer-img cursor-pointer" src={IvyLogoWithoutName} alt={this.props.translate("common.imageAlt.ivyLogo")} />
                <span className="font-10 color-white">{this.props.translate("common.copyrightMessage", { year: window.copyrightYear })}</span>
            </React.Fragment>
        )
    }

    render() {
        const { translate, appSettings } = this.props;

        return (
            <React.Fragment>
                {/* Mobile menu drawer */}
                <Drawer
                    title={appSettings.isShowRetailerProfile ? this.getTitleWithLink() : this.getTitle()}
                    placement="left"
                    closable={false}
                    onClose={this.props.drawerMenuClose}
                    visible={this.props.isShowDrawerMenu}
                    footer={this.drawerFooter()}
                    className="menu-drawer"
                >
                    <Menu
                        style={{ width: 250 }}
                        selectable={false}
                        mode="inline"
                        theme="light"
                    >
                        {appSettings.isLoading ?
                            <div className="menu-loading">
                                <Spinner message={translate("common.menu.loading")} />
                            </div>
                            :
                            <React.Fragment>
                                {/* Render menu list based on menu config API response */}
                                {appSettings.menuList.map((item, index) => {
                                    return (
                                        <Menu.Item key={index} icon={this.getMenuIcon(item)}>
                                            {this.getResponseMenuItem(item)}
                                        </Menu.Item>
                                    );
                                })}
                            </React.Fragment>
                        }

                        <Menu.Item onClick={this.confirmLogout} key="logout" icon={<i className="fa fa-sign-out fa-lg pr-2" aria-hidden="true"></i>}>
                            {translate("session.logout.logout")}
                        </Menu.Item>
                    </Menu>
                </Drawer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    translate: getTranslate(state.locale),
    appSettings: state.appSettings,
    retailer: state.localStore.user,
    notifications: state.notifications,
    orderHistory: state.orderHistory,
    cart: state.cart,
    router: state.router
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            logOut,
            push,
            clearAttrFilter,
            clearHistoryFilter,
            navigateToMyRewards
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DrawerMenu);